<template>
  <div>
    <b-modal v-if="!modalupd" id="modal-center" hide-footer centered title="Modifier Client ">
      <form @submit="UpdateClient(model.id)">
        <div class="pl-lg-4">
          <div class="row">
            <div class="col-lg-12">
              <b-form-group id="input-group-1" label="Nom et Prénom" label-for="input-1">
                <b-form-input
                  label="Nom et Prénom"
                  placeholder="Nom et Prénom"
                  input-classes="form-control-alternative"
                  v-model="model.fullname"
                  required
                />
              </b-form-group>
            </div>
            <div class="col-lg-12">
              <b-form-group id="input-group-1" label="Numero Tel" label-for="input-1">
                <b-form-input
                  label="Numero Tel"
                  placeholder="Numero"
                  input-classes="form-control-alternative"
                  v-model="model.phonenumber"
                  required
                />
              </b-form-group>
            </div>
          </div>
          <!--  <div class="row">
       
          </div>-->
        </div>

        <hr class="my-4" />
        <!-- Description -->
        <center>
          <b-btn type="submit" style="background-color:#c2b59b;color:#fff">Modifier</b-btn>
        </center>
      </form>
    </b-modal>
  </div>
</template>
<script>
import { setToken, put } from "@/mixins/api";
export default {
  name: "ModalUpdateClient",
  data() {
    return {
      modalupd: false,
      model: {
        id: "",
        fullname: "",
        phonenumber: ""
      },
      userToken:
        localStorage.getItem("userToken") ||
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEsImlhdCI6MTU3OTczNDkxMSwiZXhwIjoxNjExMjcwOTExfQ.96_I_ZUs7ALBMY4pDsnjbT-fvvagVMsVlpi48eAKWGk"
    };
  },
  methods: {
    getClient(data) {
      console.log(data);
      this.model = data;
    },
    UpdateClient(id) {
      // e.preventDefault();
      //let currentObj = this;
      put("client/" + id, this.model).then(resp => {
        this.output = resp.data.data;
        this.$emit("clientsadd", this.data, (this.modalupd = false));
      });

      this.modalupd = true;

      // e.target.reset();
    }
  },
  mounted() {
    setToken(this.userToken);
    //this.loadData();
  }
};
</script>
                        